export type ButtonVariant =
  | "primary"
  | "secondary"
  | "ghost"
  | "inverted"
  | "danger";
export type ButtonSize = "sm" | "md" | "lg";

export function getButtonClassName({
  className = "",
  size,
  variant,
}: {
  className?: string;
  size: ButtonSize;
  variant: ButtonVariant;
}): string {
  return `btn btn--${variant} btn--${size} ${className}`.trim();
}
